<template>
  <v-container>
    <v-dialog v-model="openFlag" max-width="450px" persistent>
      <c-card class="white">
        <v-row justify="center" class="mt-8 mb-3">
          <div class="title font-weight-bold">다른 시간은 어떠세요?</div>
          <div class="subTitle my-3">{{ $moment(failTime).format('HH:mm') }}에 배차 가능한 차량이 없습니다. <br />현재 이용 가능한 시간은 다음과 같습니다.</div>
        </v-row>
        <v-row>
          <v-select outlined dense :items="availableTimeList" item-text="text" item-value="value" v-model="newStartTime"/>
        </v-row>
        <div class="justify-end d-flex py-4">
          <c-btn class="mx-2" text color="gray" @click="cancelAutoReservation">취소</c-btn>
          <c-btn class="mx-2" text color="blue" @click="reReservation">재배차 요청</c-btn>
        </div>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    reservationId: {
      type: String,
      default: '',
    },
    failTime: {
      type: String,
      default: '',
    },
    autoReservationFlag: {
      type: Boolean,
      default: false
    },
    availableTimeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      openFlag: false,
      newStartTime: '',
      dayValue: '',
    }
  },
  watch: {
    open(newVal) {
      this.openFlag = newVal;
      this.findCloserTime();
    },
    openFlag(val) {
      this.$emit('update:open', val);
    },
    failTime(newVal) {
      this.dayValue = this.$moment(newVal).format('YYYY-MM-DD');
    }
  },
  methods: {
    reReservation() {
      this.$emit('reqAutoReservation', this.reservationId, this.newStartTime);
    },
    cancelAutoReservation() {
      this.$emit('cancelAutoReservation', this.reservationId)
    },
    findCloserTime() {
      const availableTimes = this.availableTimeList;
      const failTime = this.failTime;

      const referTime = this.$moment(failTime);
      let resultTime = '';

      const lastIdx = availableTimes.length - 1;

      for(let i = 0; i < availableTimes.length; i++) {
        let comparisonVal = this.$moment(availableTimes[i].value);

        if (i !== lastIdx && referTime > comparisonVal) continue;
        else if (i === lastIdx) resultTime = availableTimes[lastIdx].value;
        else {
          // referTime이 comparisonVal 보다 작아지는 시점에서 이전 idx 값과 절대값을 비교해서 결과를 도출
          // idx가 0일 경우 첫번째 값
          if (i === 0) resultTime = availableTimes[i].value;
          else {
            // 현재 idx의 절대값
            const gap = Math.abs(referTime.diff(comparisonVal));
            const beforeGap = Math.abs(referTime.diff(this.$moment(availableTimes[i - 1])));

            // 이전/이후 gap 이 동일할 경우 체크 -> 이전 시간 표시
            if (gap > beforeGap) resultTime = availableTimes[i - 1].value;
            else if (gap < beforeGap) resultTime = availableTimes[i].value;
            else resultTime = availableTimes[i - 1].value;
          }
          break;
        }
      }
      this.newStartTime = resultTime;
    }
  }
}
</script>

<style scoped>

</style>
